var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cgqBox"},[_c('div',{staticClass:"cgqBoxTil"},[_vm._v("\n\t\t\t一体防水·高效洗消\n\t\t")]),_c('div',{staticClass:"cgqBoxCen"},[_vm._v("\n\t\t\t一键插拔，即用即插，减少内镜连接及脱机的繁琐步骤\n\t\t\t无需防水盖即可进行洗消，缩减工作流程及时间\n\t\t")]),_c('div',{staticClass:"cgqBoxSp"},[_c('video',{attrs:{"src":""}})])])])
}]

export { render, staticRenderFns }